import { PARTITION } from './constants';
import type { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];
const selectAccounts = (state: any) => selectPartition(state) && selectPartition(state).accounts;
const selectSupplierBuyerAssociation = (state: any) => selectPartition(state) && selectPartition(state).supplierBuyerAssociation;
const selectSelectedAccount = (state: any) => selectPartition(state) && selectPartition(state).selectedAccount;
export default {
  selectPartition,
  selectAccounts,
  selectSupplierBuyerAssociation,
  selectSelectedAccount,
};
